import React from "react";
import { Fade } from "react-bootstrap";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { push } from "react-router-redux";
import * as redux from "redux";
import * as Comp from "./";
import * as Actions from "../actions";
import { AdminRoutes, AppRoutes, LoginRoute, PwResetRoute } from "../routes";
import Settings from "../settings";
import { AppState } from "../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => {
    // console.log("nav initialized", state.nav.initialized);
    // console.log("auth initialized", state.auth.initialized);
    // console.log("countries loading", state.countries.loading);
    // console.log("all", (state.nav.loading && !state.nav.hasStorageNav)
    //     || !state.auth.initialized
    //     || state.countries.loading);

    // console.log("conn", state.conn.connected, "auth", state.auth.initialized, "nav", state.nav.initialized, "country", state.countries.initialized);

    return {
        authInitialized: state.auth.initialized,
        hasToken: state.auth.accessToken !== undefined,
        isServerRendering: state.ssr.isSSR,
        landingUrl: state.router.location ? state.router.location.pathname : undefined,
        showSiteLoading: (state.nav.loading && !state.nav.hasStorageNav)
            || !state.auth.initialized,
    };
};

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    initAbstractsWebsocket: () => dispatch(Actions.Abstract.initConnection()),
    initAuth: (clientId: string, clientSecret: string) => dispatch(Actions.Auth.init(clientId, clientSecret)),
    initConn: () => dispatch(Actions.Conn.initialize()),
    initDbSubs: () => dispatch(Actions.DBSubs.init()),
    initNav: () => dispatch(Actions.Nav.init()),
});

type OwnProps = RouteComponentProps<{}> & {
    clientId: string;
    clientSecret: string;
};

interface ConnectedState {
    authInitialized: boolean;
    hasToken: boolean;
    isServerRendering: boolean;
    landingUrl?: string;
    showSiteLoading: boolean;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    initAbstractsWebsocket: () => void;
    initAuth: (clientId: string, clientSecret: string) => void;
    initConn: () => void;
    initDbSubs: () => void;
    initNav: () => void;
}

interface OwnState {}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AppComponent extends React.Component<CombinedProps, OwnState> {

    private appLoading: HTMLElement | null = null;

    public constructor(props: ConnectedState & ConnectedDispatch & OwnProps) {
        super(props);
    }

    public componentDidMount() {
        this.appLoading = document.getElementById("app-loading");
    }

    public async componentWillMount() {
        await this.props.initConn();
        await this.props.initAuth(this.props.clientId, this.props.clientSecret);
        await this.props.initNav();
        this.props.initDbSubs();
        this.props.initAbstractsWebsocket();
    }

    public componentWillReceiveProps(nextProps: CombinedProps) {
    }

    public render() {
        if (this.props.showSiteLoading) {
            if (this.appLoading !== null) {
                this.appLoading.classList.remove("fadeout");
            }

            // return null only if not server-side-rendering
            // because we need to catch the static context on render
            if (!this.props.isServerRendering)
                return null;
        }
        else {
            // show/hide site loading element
            if (this.appLoading !== null) {
                setTimeout(() => {
                    if (!this.props.showSiteLoading && this.appLoading !== null)
                        this.appLoading.classList.add("fadeout");
                }, 125);
            }
        }

        return <Comp.Error.ErrorBoundary>
            <Comp.Page.ScrollRestore { ... this.props } />
            <Comp.Responsive.Responsive />
            <Comp.Generic.ConnectionStatus />
            <Comp.Notification.SiteNotifications />
            <Helmet><title>{Settings.ClientName}</title></Helmet>
            <Fade in={!this.props.showSiteLoading}>
                <Switch>
                    {/* Specific layout-less signin page */}
                    {LoginRoute}
                    {PwResetRoute}

                    {/* admin app pages */}
                    <Route path="/admin" render={(routeProps) =>
                        (<div id="root">
                            <div id="body-wrapper">
                                <div id="app-wrapper">
                                    <Comp.Admin.Menu />
                                    <AdminRoutes />
                                </div>
                            </div>
                        </div>)
                    } />

                    {/* All other app pages */}
                    <Route path="/" render={(routeProps) =>
                        [
                            <Comp.Admin.AdminRibbon key={1} />,
                            <Comp.Layout.UtilityMenu key={2} />,
                            <div id="wrapper" key={3}>
                                <div id="page">
                                    <Comp.Layout.Header />
                                    <Comp.Nav.MainMenu />
                                    <AppRoutes />
                                </div>
                                <Comp.Layout.Footer />
                            </div>,
                            <div id="credit" key={4}><a href="https://www.webitects.com">Designed and built in Chicago by <strong>Webitects</strong></a></div>,
                        ]
                    } />
                </Switch>
            </Fade>
        </Comp.Error.ErrorBoundary>;
    }
}

export const App: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(AppComponent) as any);



// WEBPACK FOOTER //
// ./src/components/app.tsx